
import type { IconProps } from 'src/types/icons';

const PaidIcon = (props: IconProps) => (
  <svg {...props} width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.746826" y="0.75" width="30" height="30" rx="10" fill="#48C898" />
    <path d="M11.6281 21.9021C12.1488 22.4228 12.993 22.4228 13.5137 21.9021L23.5986 11.8172C24.1193 11.2965 24.1193 10.4522 23.5986 9.93154C23.0779 9.41084 22.2337 9.41084 21.713 9.93154L11.6281 20.0165C11.1074 20.5372 11.1074 21.3814 11.6281 21.9021Z" fill="white" stroke="white" strokeWidth="0.3" />
    <path d="M7.34218 15.8456C7.86288 15.3249 8.7071 15.3249 9.2278 15.8456L13.218 19.8358C13.7387 20.3565 13.7387 21.2007 13.218 21.7214C12.6973 22.2421 11.8531 22.2421 11.3324 21.7214L7.34218 17.7312C6.82149 17.2105 6.82149 16.3663 7.34218 15.8456Z" fill="white" stroke="white" strokeWidth="0.3" />
  </svg>

);
export default PaidIcon;
